import { ActionCode } from '../constants/actions.constants';

export class AppHasActionUtil {
  
  static hasAction(actionCode: ActionCode): boolean {
    try {
      const userActions = localStorage.getItem('userActions');
      if (!userActions) {
        return false;
      }

      const actions = JSON.parse(userActions);
      if (!Array.isArray(actions)) {
        return false;
      }

      return actions.some((action: any) => action.code === actionCode);
    } catch (error) {
      return false;
    }
  }

  static hasAllActions(actionCodes: ActionCode[]): boolean {
    return actionCodes.every(actionCode => this.hasAction(actionCode));
  }

  static hasAnyAction(actionCodes: ActionCode[]): boolean {
    return actionCodes.some(actionCode => this.hasAction(actionCode));
  }

  static getUserActions(): any[] {
    try {
      const userActions = localStorage.getItem('userActions');
      if (!userActions) {
        return [];
      }

      const actions = JSON.parse(userActions);
      return Array.isArray(actions) ? actions : [];
    } catch (error) {
      return [];
    }
  }

  static isUserLoggedIn(): boolean {
    const actions = this.getUserActions();
    return actions.length > 0;
  }
}

export function hasAction(actionCode: ActionCode): boolean {
  return AppHasActionUtil.hasAction(actionCode);
}

export function hasAllActions(actionCodes: ActionCode[]): boolean {
  return AppHasActionUtil.hasAllActions(actionCodes);
}

export function hasAnyAction(actionCodes: ActionCode[]): boolean {
  return AppHasActionUtil.hasAnyAction(actionCodes);
}
